import { formatProcessingMatchBanner } from './mergeStandingsLiveEvent';

export const STANDINGS_UPDATED_TOAST_MESSAGE = 'Standings updated';

/**
 * Toast payload for a live STANDINGS_PROCESSING AppSync event.
 * @param {object | null | undefined} event
 * @returns {{ id: string, message: string } | null}
 */
export function toastFromStandingsProcessingEvent(event) {
  if (event?.type !== 'STANDINGS_PROCESSING' || !event.match) return null;
  const message = formatProcessingMatchBanner(event.match);
  if (!message) return null;
  const id = String(event.gameId || event.match.gameId || 'standings-processing');
  return { id, message };
}

/**
 * Toast that replaces a processing toast when STANDINGS_UPDATED arrives.
 * @param {object | null | undefined} event
 * @returns {{ id: string, message: string } | null}
 */
export function toastFromStandingsUpdatedEvent(event) {
  if (event?.type !== 'STANDINGS_UPDATED') return null;
  const id = String(event.gameId || 'standings-updated');
  return { id, message: STANDINGS_UPDATED_TOAST_MESSAGE };
}
